module.exports = "<div class=\"text-danger\" *ngIf=\"errorMessage !== null\">{{errorMessage}}</div>\n"